import gql from "graphql-tag";

const ModelProps = gql`
	fragment ModelProps on PatientAssessment {
		id
		confirm {
			datetime
			status
		}
		score {
			desc
			value
		}
		created_at
		author {
			id
			surname
			first_name
			middle_name
			designation {
				id
				name
			}
			type {
				id
				name
			}
			email
			image
		}
	}
`;

const LIST = gql`
	query GetPatientAssessments(
		$id: ID!
		$assessment: ID!
		$page: Int
		$limit: Int
	) {
		GetPatientAssessments(
			id: $id
			assessment: $assessment
			page: $page
			limit: $limit
		) {
			docs {
				...ModelProps
			}
			page
			limit
			totalDocs
			totalPages
			prevPage
			nextPage
		}
		GetAssessmentQuestionsByCategory(id: $assessment) {
			docs {
				count
				category {
					id
					name
				}
				questions {
					id
					name
					allowMultipleSelection
					options {
						id
						name
						value
					}
				}
			}
		}
		GetAssessment(id: $assessment) {
			doc {
				id
				name
				scoreGuide {
					desc
					label
					max
					min
				}
				additional
			}
		}
	}
	${ModelProps}
`;

const CREATE = gql`
	mutation NewPatientAssessment(
		$assessment: ID!
		$model: InputPatientAssessment!
		$confirm: Boolean!
	) {
		RecordPatientAssessment(
			assessment: $assessment
			model: $model
			confirmed: $confirm
		) {
			message
			doc {
				...ModelProps
			}
		}
	}
	${ModelProps}
`;

const CONFIRM = gql`
	mutation ConfirmPatientAssessment($id: ID!) {
		ConfirmPatientAssessment(id: $id) {
			message
			doc {
				...ModelProps
			}
		}
	}
	${ModelProps}
`;

const SINGLE = gql`
	query GetPatientAssessment($id: ID!) {
		GetPatientAssessment(id: $id) {
			doc {
				...ModelProps
				questions {
					question {
						id
						name
					}
					options {
						id
						name
						value
					}
				}
				additional {
					key
					value
				}
				admission {
					id
					admission_date
					discharge_date
					bed {
						id
						name
						room {
							id
							name
							ward {
								id
								name
							}
						}
					}
				}
			}
		}
	}
	${ModelProps}
`;
export { LIST, CREATE, CONFIRM, SINGLE };
